import { ReactNode } from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
  width: 100%;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

  .l-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;

    h2 {
      font-size: 2.5rem;
    }

    span {
      text-align: center;
    }
  }
`;

export interface CardProps {
  icon?: ReactNode;
  value: number;
  title: string;
}

export function MetricsCard({ icon, title, value }: CardProps) {
  return (
    <CardWrapper>
      <div className="l-info">
        <h2>{value}</h2>
        <span>{title}</span>
      </div>
      {icon}
    </CardWrapper>
  );
}
